// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ROrD-","column":"styles_column__gWzaI"};